import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import { apiCall } from '../../../action/RouterActions'
import CustomButton from '../../CustomButton'
import { useTranslation } from 'react-i18next'

const AddInstallReportModal = (props) => {
	const dispatch = useDispatch();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.editAssetContainer.addInstallReportModal' });
	const { user, device, onHide, showInstallReport } = props;

	const [data, setData] = useState({
		first_name: "",
		last_name: "",
		email: "",
		phone_number: "",
		installer_company_name: "",
		mecp_cert: false,
		windshield_img: "",
		obd_mount: "",
		obd_zip_tie: "",
		antenna_img: "",
		power_img: "",
		pdc_img: "",
		modem_img: ""
	});
	const [showModalImageView, setShowModalImageView] = useState(false);
	const [imageViewSRC, setImageViewSRC] = useState("");
	const [imgValue, setImgValue] = useState({
		value_1: "",
		value_2: "",
		value_3: "",
		value_4: "",
		value_5: "",
		value_6: "",
		value_7: ""
	});

	const toggleLoader = useCallback((show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}, [dispatch]);

	const sendData = () => {
		toggleLoader(true);
		const dataSend = data;
		if (data.phone_number?.length < 10) {
			toastr.error(i18n.t('errorMessage.errPhoneNumberLength'));
			toggleLoader(false);
			return;
		} else if (data.phone_number?.length > 10) {
			toastr.error(i18n.t('errorMessage.errPhoneNumber'));
			toggleLoader(false);
			return;
		}
		for (let item in dataSend) {
			if (!dataSend[item]) dataSend[item] = "";
		}
		apiCall('POST', `/devices/${device.device_id}/install_report`, dataSend)
			.then(res => {
				toggleLoader(false);
				if (res.data.response.message === "success") {
					onHide();
					showInstallReport();
					toastr.success('', t('installReportUploaded'));
				} else {
					toastr.error(i18n.t('errorMessage.errDescription'));
				}
			})
			.catch((error) => {
				console.log('Error: ', error.response, error)
				toggleLoader(false);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
					if (errDescription.includes("jpeg|jpg|png")) errDescription = errDescription.replaceAll('|', '/');
				}
				toastr.error(errDescription)
			})
	}

	const fillForm = (e) => {
		const { name } = e.target;
		const value = (name === 'phone_number') ? e.target.value.replace(/[^\d]/g, '') : e.target.value;

		setData({ ...data, [name]: value });
	};

	const hideModalImageView = () => {
		setShowModalImageView(false);
		setImageViewSRC("");
	}

	const viewUploadFile = (name) => {
		setImageViewSRC(window.URL.createObjectURL(data[name]));
		setShowModalImageView(true);
	}

	const deleteUploadFile = (name, value) => {
		setData({ ...data, [name]: "" });
		setImgValue({ ...imgValue, [value]: "" });
	}

	const onFileChange = (e, name) => {
		setData({ ...data, [name]: e.target.files[0] });
		setImgValue({ [e.target.id]: e.target.value });
	}

	const file_1 = "windshield_img";
	const file_2 = "obd_mount";
	const file_3 = "obd_zip_tie";
	const file_4 = "antenna_img";
	const file_5 = "power_img";
	const file_6 = "pdc_img";
	const file_7 = "modem_img";
	let dataSendAccess = Object.values(data).reduce((prev, current) => !!prev || !!current, false);

	return (
		<Modal dialogClassName="addInstallReportModal"
			show
			onHide={onHide}
		>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('addInstallReport')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<h5>{t('installerInfo')}</h5>
				<div className="formReportInstall">
					<div className="itemRow">
						<input
							type="text"
							name="first_name"
							value={data.first_name}
							placeholder={t('firstName')}
							className="firstNameInput"
							onChange={fillForm}
						/>
						<input
							type="text"
							value={data.last_name}
							placeholder={t('lastName')}
							className="lastNameInput"
							onChange={fillForm}
						/>
					</div>
					<div className="itemInput">
						<input
							type="text"
							name="email"
							value={data.email}
							placeholder={t('email')}
							className="fullWidthInput"
							onChange={fillForm}
						/>
					</div>
					<div className="itemInput">
						<input
							type="text"
							name="phone_number"
							value={data.phone_number}
							placeholder={t('phoneNumber')}
							className="fullWidthInput"
							onChange={fillForm}
						/>
					</div>
					<div>
						<input
							type="text"
							name="installer_company_name"
							value={data.installer_company_name}
							placeholder={t('installerCompanyName')}
							className="fullWidthInput"
							onChange={fillForm}
						/>
					</div>
					<div className="itemInput">
						<label className="control-label lbl-certified">{t('MECPCertified')}</label>
						<div className="itemRow-checkbox">
							<input
								type="checkbox"
								name="mecp_cert"
								checked={data.mecp_cert}
								onChange={(e) => setData({ ...data, mecp_cert: e.target.checked })}
							/>
							<label>{t('labelYes')}</label>
						</div>
						<hr />
					</div>
					<div className="upload-files">
						<div className="itemRow">
							<label className="control-label load-image">{t('cameraOnWindshield')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_1} className="upload-input" id="value_1" onChange={e => onFileChange(e, file_1)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_1] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_1)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_1, "value_1")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
						<div className="itemRow">
							<label className="control-label load-image">{t('OBDConnection')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_2} className="upload-input" id="value_2" onChange={e => onFileChange(e, file_2)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_2] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_2)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_2, "value_2")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
						<div className="itemRow">
							<label className="control-label load-image">{t('OBDZipTie')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_3} className="upload-input" id="value_3" onChange={e => onFileChange(e, file_3)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_3] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_3)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_3, "value_3")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
						<div className="itemRow">
							<label className="control-label load-image">{t('antenna')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_4} className="upload-input" id="value_4" onChange={e => onFileChange(e, file_4)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_4] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_4)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_4, "value_4")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
						<div className="itemRow">
							<label className="control-label load-image">{t('powerConnection')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_5} className="upload-input" id="value_5" onChange={e => onFileChange(e, file_5)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_5] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_5)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_5, "value_5")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
						<div className="itemRow">
							<label className="control-label load-image">{t('PDC')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_6} className="upload-input" id="value_6" onChange={e => onFileChange(e, file_6)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_6] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_6)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_6, "value_6")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
						<div className="itemRow">
							<label className="control-label load-image">{t('Modem/Router')}</label>
							<CustomButton><label className="lbl">{t('Upload')}<input type="file" value={imgValue.value_7} className="upload-input" id="value_7" onChange={e => onFileChange(e, file_7)} /></label></CustomButton>
							<label className="control-label item-right">{!!data[file_7] ? <div><a className="btn-view-image" onClick={() => viewUploadFile(file_7)}>{t('Preview')}</a><a className="btn-delete-image" onClick={() => deleteUploadFile(file_7, "value_7")}>{t('Delete')}</a></div> : t('noSnapshot')}</label>
						</div>
					</div>
					<hr />
				</div>
			</Modal.Body>
			<Modal.Footer>
				<CustomButton variant="primary" onClick={() => onHide()}>{t('Cancel')}</CustomButton>
				<CustomButton variant="primary" disabled={!dataSendAccess} onClick={() => sendData()}>{t('Add')}</CustomButton>
			</Modal.Footer>
			{showModalImageView
				&& (
					<ModalImageView
						src={imageViewSRC}
						onHide={hideModalImageView}
					/>
				)}
		</Modal>
	)
}

AddInstallReportModal.propTypes = {
	device: PropTypes.objectOf(PropTypes.any).isRequired,
	onHide: PropTypes.func.isRequired
}

const ModalImageView = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.editAssetContainer.addInstallReportModal' });
	const { src, onHide } = props;
	return (
		<Modal
			show
			onHide={onHide}
			size="large"
			backdropClassName="upper"
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-lg">{t('titleImageView')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>
					<img src={src} width="100%" id="event-snapshot" alt="" />
				</div>
			</Modal.Body>
		</Modal>
	);
}

export default AddInstallReportModal;
